/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Request aliases dictionary
 */
export enum RequestAlias {
  Authenticate = "Authenticate",
  RefreshToken = "RefreshToken",
  GetMyPayments = "GetMyPayments",
  GetMyInvoices = "GetMyInvoices",
  GetMyInvoicesDetails = "GetMyInvoicesDetails",
  GetInvoicePrint = "GetInvoicePrint",
  GetMyComplaints = "GetMyComplaints",
  GetComplaintQuantityAvailable = "GetComplaintQuantityAvailable",
  CreateComplaint = "CreateComplaint"
}
